import React, {Component} from 'react'
import { connect, Provider } from "react-redux"
import FileInputComponent from 'react-file-input-previews-base64'

import {
    css,
    Grid,
    GridCell,
    Theme,
    modal,
    Toggler,
    Button,
    Div,
    confirm,
    Icon,
} from "@bdfx/mergado-ui-kit"

import trans from "trans"
import store from "store"
import { initForm, updateInputValue as change } from "app/reducers/form"
import { CollageLayoutImageType, CollageLayoutType, Template } from 'app/types/model-types';
import {RandomProduct} from "shape-edit/types";
import AlternativeImageSvg from "shape-entities/components/alternative-image-svg";
import {createToast, setHelper} from "actions";
import {iconDisabledColor} from "./tools-panel";
import CollageLayouts from "settings/components/collage-layouts";
import {
    deleteCollageLayout as apiDeleteCollageLayout,
    addCollageLayout as apiAddCollageLayout,
    createDefaultLayouts as apiCreateDefaultLayouts,
    deleteAllUnused as apiDeleteAllUnused,
    getProjectCollageLayouts,
    importCollageLayouts,
    exportCollageLayouts,
    projectId,
} from "app/helpers/api";
import {
    ADD_COLLAGE_LAYOUT,
    DELETE_COLLAGE_LAYOUTS,
    CREATE_DEFAULT_COLLAGE_LAYOUTS,
    DELETE_ALL_UNUSED_COLLAGE_LAYOUTS,
} from "../reducers";

import toastFactory from "app/helpers/toast_factory"
import {AxiosResponse} from "axios";
import { getTemplateSize } from 'shape-edit/forms/helpers'
import { renderClipMaskShape } from './helper'
import { ClipMaskObject, EmptyClipMaskObject } from 'shape-edit/forms/edit-clip-mask-modal'
import { selectFormValues } from 'app/reducers/form'
import { HelperType, ID } from 'app/types/app-types'
import { FileInputType, MAX_FILE_SIZE } from 'template-list/containers/template-list'
import { isNumeric } from 'app/helpers/other'
import { omitBy } from 'lodash'

const ALLOWED_FILE_TYPES = [
    "application/json",
    "text/plain",
]

interface Props {
    isEditTemplateMode: boolean
    templateForm: Template
    randomProduct: RandomProduct
    collageLayoutsForm: CollageLayoutType[]
    initForm: typeof initForm
    change: typeof change
    helper: HelperType
    setHelper: typeof setHelper
}

interface State {
    isCreating: boolean,
    isSaving: boolean,
}

const layoutSize = 140

class EditLayout extends Component<Props,State> {
    constructor(props) {
        super(props)

        this.state = {
            isCreating: false,
            isSaving: false,
        }
    }

    componentDidMount(): void {
        if (!this.props.collageLayoutsForm || Object.keys(this.props.collageLayoutsForm).length === 0) {
            getProjectCollageLayouts()
                .then((response: AxiosResponse<CollageLayoutType[]>) => {
                    this.props.initForm('collageLayoutsForm', response.data)
                })
                .catch((error) => {
                    console.error('cannot load collage layouts', error)
                })
        }
    }

    exportLayouts = (ids: number[]) => {
        exportCollageLayouts(ids)
            .then((response: AxiosResponse<CollageLayoutType[]>) => {
                const url = window.URL.createObjectURL(new Blob([JSON.stringify(response.data)]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', `collage_layout_${projectId}_${ids.join('-')}.json`);
                document.body.appendChild(link);
                link.click();
            })
            .catch(error => {
                console.error('cannot import collage', error)
            })
    }

    importLayouts = (file: FileInputType) => {
        console.debug(`start importing collage layout from file: ${file.type}, size: ${file.size}`)

        if (file.size <= MAX_FILE_SIZE && ALLOWED_FILE_TYPES.includes(file.type)) {
            importCollageLayouts(file.base64, file.name)
                .then((response: AxiosResponse<CollageLayoutType[]>) => {
                    this.props.initForm('collageLayoutsForm', response.data)
                })
                .catch(error => {
                    console.error('cannot import collage', error)
                })
        } else {
            console.error(`Unsupported file: ${file.type}, size: ${file.size}`)
        }
    }

    showEditLayouts = (id: number) => {
        this.props.setHelper({ ...this.props.helper, isMaximized: false, closedAt: this.props.helper.closedAt ? this.props.helper.closedAt : Date.now() })

        modal({
            overlayClassName: 'edit-collages-modal',
            style: {
                maxWidth: 'calc(100vw - 14px)',
                maxHeight: 'calc(100vh - 2px)',
                backgroundColor: '#fffffff0',
                border: '1px solid #cccccc',
                padding: '8px',
            },
            message: (close) => <Provider store={store}>
                <CollageLayouts id={id} closeModal={close} />
            </Provider>,
            hideCloseButton: true,
            closeOnClickOutside: false,
            fullscreen: true,
        })
    }

    selectLayout = (layout: CollageLayoutType) => {
        const {templateForm} = this.props
        this.props.initForm('templateForm', {
            ...templateForm,
            collage_layout_id: layout.id,
            collage_layout: layout,
        })
    }

    removeLayout = (id: ID) => {
        confirm({
            message: trans("delete_layout")+"?",
            buttons: [
                <Button key="yes" onClick={() => {
                    //tady mazat jenom pokud je ciste numericky, jinak pouze z formu:
                    if (isNumeric(id)) {
                        apiDeleteCollageLayout(id)
                        .then((response: AxiosResponse<CollageLayoutType[]>) => {
                            store.dispatch(createToast(toastFactory(DELETE_COLLAGE_LAYOUTS.SUCCESS)))
                            this.props.initForm('collageLayoutsForm', response.data)    //refresh form
                        })
                        .catch(error => {
                            store.dispatch(createToast(toastFactory(DELETE_COLLAGE_LAYOUTS.ERROR, error)))
                        })
                    } else {
                        const updatedCollagelayoutForm = omitBy(this.props.collageLayoutsForm, (collageLayout) => `${collageLayout.id}` === `${id}`)
                        this.props.initForm('collageLayoutsForm', updatedCollagelayoutForm)
                    }
                }}>{trans('yes')}</Button>,
                <Button key="no" onClick={() => false}>{trans('no')}</Button>]
        })
    }

    renderPreviewClipMasks = (layoutWidth: number, layoutHeight: number, collageLayout: CollageLayoutType, scale: number) => {
        if (!layoutWidth || !layoutHeight || !collageLayout || !collageLayout.images || collageLayout.images.length === 0) {
            return <React.Fragment />
        }

        return <React.Fragment>
            {Object.keys(collageLayout.images).map((i) => {
                const image: CollageLayoutImageType = collageLayout.images[i]

                const clipPathId = `collage-clip-path-select-${collageLayout.id}-${image.id}`

                const scaleX = layoutWidth * collageLayout.rel_width
                const scaleY = layoutHeight * collageLayout.rel_height

                const width = (scaleX * image.width_rel - 2 * image.padding_px * scale)
                const height = (scaleY * image.height_rel - 2 * image.padding_px * scale)

                let thisWidth = width
                let thisHeight = height

                if (image.shape === 'circle') {
                    const minSide = Math.min(thisWidth, thisHeight)
                    thisWidth = minSide
                    thisHeight = minSide
                }

                const points = image.points ? JSON.parse(image.points) : [] //bezier nebo polygon
                let scaledPoints = [...points]  //relative units to pixels
                scaledPoints.forEach((point, index) => {
                    points[index].x = scaleX * image.width_rel * point.x
                    points[index].y = scaleY * image.height_rel * point.y

                    if (typeof point.cx !== 'undefined') {
                        points[index].cx = scaleX * image.width_rel * point.cx
                    }

                    if (typeof point.cy !== 'undefined') {
                        points[index].cy = scaleY * image.height_rel * point.cy
                    }
                })

                const maskObject: ClipMaskObject = {
                    ...EmptyClipMaskObject,
                    width: thisWidth,
                    height: thisHeight,
                    padding: image.padding_px,
                    /* angle: image.angle, */
                    x: 0,
                    y: 0,
                    isFilled: true,
                    type: image.shape ? image.shape : 'rect',
                    points: scaledPoints,
                }

                return <clipPath key={clipPathId} id={clipPathId} transform={`translate(${width / 2}, ${height / 2})`}>
                    {renderClipMaskShape(maskObject, false)}
                </clipPath>
            })}

        </React.Fragment>
    }

    render() {
        const { randomProduct, templateForm, templateForm: { collage_layout_id }, collageLayoutsForm, isEditTemplateMode } = this.props
        const { isCreating, isSaving } = this.state

        const templateSize = getTemplateSize()
        const ratio = (templateSize.width && templateSize.height && templateSize.width > 0) ? templateSize.height / templateSize.width : 1

        const mappedLayouts = collageLayoutsForm ?
            <StyledLayoutsGrid>
                {Object.keys(collageLayoutsForm).reverse().map((id, idx) => {
                    const layout = collageLayoutsForm[id]
                    const isTemporary = `${layout.id}`.startsWith('_')

                    const width = layoutSize
                    const height = layoutSize * ratio

                    const scale = layoutSize / templateSize.width

                    return <GridCell key={layout.id} className={`choose-layout ${`${collage_layout_id}` === `${layout.id}` ? 'selected' : ''}`} style={{ borderRadius: '5px', padding: '5px' }}>
                        <div onClick={() => this.selectLayout(layout)}>
                            <svg id={`collage-layout-${layout.id}`} width={width} height={height} style={{ border: `1px solid ${Theme.blue}` }}>
                                <defs>
                                    {this.renderPreviewClipMasks(width, height, layout, scale)}
                                </defs>

                                <AlternativeImageSvg
                                    layoutWidth={layoutSize}
                                    layoutHeight={layoutSize * ratio}
                                    selectedCollage={layout}
                                    randomProduct={randomProduct}
                                    isShadow={false}
                                    isAnim={false}
                                    previewMode={true}
                                />
                            </svg>
                            <div className={`layout-name`}>{isTemporary ? '*' : ''}{layout.name}</div>
                        </div>
                        <Div padding="0 20px 10px">
                            <Button style={{ float: "left" }} size={"tiny"} title={trans("edit")} simple={true} icon="edit" onClick={(e) => this.showEditLayouts(layout.id)} />
                            <Button style={{ float: "right" }} size={"tiny"} title={trans("delete")} color="red" simple={true} icon="trash" onClick={(e) => this.removeLayout(layout.id)} />
                            <Button style={{ float: "right" }} size={"tiny"} title={trans("export_layouts")} simple={true} icon="download-radix" onClick={(e) => this.exportLayouts([layout.id])} />
                        </Div>
                    </GridCell>
                })}
            </StyledLayoutsGrid> : null

        const iconSize = 18

        return (
            <StyledDiv className={'padding'}>
                <Grid cols={'auto auto'}>
                    <GridCell>
                        <div style={{ marginTop: '14px' }}>
                            <Button
                                type={"void"}
                                secondary={true}
                                icon={<Icon type={'add-light'} size={iconSize} text={trans("add_layout")} color={Theme.blue} />}
                                onClick={() => {
                                    apiAddCollageLayout()
                                        .then((response: AxiosResponse<CollageLayoutType[]>) => {
                                            store.dispatch(createToast(toastFactory(ADD_COLLAGE_LAYOUT.SUCCESS)))
                                            this.props.initForm('collageLayoutsForm', response.data)    //refresh form
                                        })
                                        .catch(error => {
                                            store.dispatch(createToast(toastFactory(ADD_COLLAGE_LAYOUT.ERROR, error)))
                                        })
                                }}
                            />
                        </div>
                    </GridCell>

                    <GridCell style={{textAlign: 'right'}}>
                        <FileInputComponent
                            labelText={null}
                            imagePreview={false}
                            multiple={false}
                            buttonComponent={
                                <Button
                                    type={'void'}
                                    secondary={true}
                                    icon={<Icon type={'upload'} size={iconSize} text={trans("import_layouts")} color={Theme.blue} />}
                                    text={trans('import_layouts')}
                                />
                            }
                            callbackFunction={this.importLayouts}
                            accept="application/json"
                        />
                    </GridCell>
                </Grid>

                <StyledFormatsFormGrid>
                    <GridCell col={'span 3'}>
                        {mappedLayouts}
                    </GridCell>
                </StyledFormatsFormGrid>

                <br />

                {isEditTemplateMode &&
                    <Div textAlign="left" marginBottom="10px" >
                        <StyledToggler
                            style={{ ".m-isinvalid": { float: "none" }, ".m-onlabel": { fontSize: "12px", whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis", }, ".muk-form-label": { width: "auto" } }}
                            onLabel={trans('all_available_only')}
                            value={templateForm.collage_all_available_only || 0}
                            onChange={(e) => this.props.change('templateForm', 'collage_all_available_only', e)}
                        />
                    </Div>
                }

                <Grid cols="auto auto" style={{marginTop: '20px'}}>
                    <GridCell>
                    <Button
                        type={"void"}
                        secondary={true}
                        color={'red'}
                        icon={<Icon type={isCreating ? 'spinner' : 'trash'} size={iconSize} text={trans("delete_all_unused")} />}
                        onClick={() => {
                            if (!isCreating) {
                                this.setState({ isCreating: true })
                                apiDeleteAllUnused()
                                    .then((response: AxiosResponse<CollageLayoutType[]>) => {
                                        store.dispatch(createToast(toastFactory(DELETE_ALL_UNUSED_COLLAGE_LAYOUTS.SUCCESS)))
                                        this.props.initForm('collageLayoutsForm', response.data)
                                    })
                                    .catch(error => {
                                        store.dispatch(createToast(toastFactory(DELETE_ALL_UNUSED_COLLAGE_LAYOUTS.ERROR, error)))
                                    })
                                    .finally(() => this.setState({ isCreating: false }))
                            }
                        }}
                        />
                    </GridCell>
                    <GridCell style={{textAlign: 'right'}}>
                    <Button
                        type={"void"}
                        secondary={true}
                        icon={isCreating ?
                            <Icon type={'spinner'} size={iconSize} text={trans("create_default_layouts")} /> :
                            <Icon type={'magic'} size={iconSize} text={trans("create_default_layouts")} />}
                        onClick={() => {
                            if (!isCreating) {
                                this.setState({ isCreating: true })
                                apiCreateDefaultLayouts()
                                    .then((response: AxiosResponse<CollageLayoutType[]>) => {
                                        store.dispatch(createToast(toastFactory(CREATE_DEFAULT_COLLAGE_LAYOUTS.SUCCESS)))
                                        this.props.initForm('collageLayoutsForm', response.data)
                                    })
                                    .catch(error => {
                                        store.dispatch(createToast(toastFactory(CREATE_DEFAULT_COLLAGE_LAYOUTS.ERROR, error)))
                                    })
                                    .finally(() => this.setState({ isCreating: false }))
                            }
                        }}
                        />
                        </GridCell>
                </Grid>
            </StyledDiv>
        )
    }
}

const StyledFormatsFormGrid = css(Grid)({
    marginTop: '10px',
    gridTemplateColumns: '120px auto auto',
    gridGap: '5px',
    '@media screen and (max-width: 1400px)': {
        gridTemplateColumns: '100px auto auto',
    },
    '@media screen and (max-width: 1200px)': {
        gridTemplateColumns: '80px auto auto',
    },
})

const StyledDiv = css("div")({
    fontSize: '14px',
    ' .placeholder': {
        color: iconDisabledColor,
        position: 'absolute',
        top: '10px',
        left: '10px',
        zIndex: 10,
    },
    ' .shorter': {
        ' input': {
            paddingLeft: '30px',
        },
    },
    ' .alt-image-layout': {
        fill: '#eee',
    },
    ' .shadow-box': {
        ' .alt-image-layout': {
            fill: '#cce4fb',
            stroke: '#fff',
        },
    },
    ' .date-range-form': {
        /*position: 'relative',*/
    },
    ' .date-range-form-label': {
        alignSelf: 'center',
        position: 'relative',
    },
    ' .muk-datepicker': {
        position: 'unset',
    },
    ' .muk-datepicker-popover': {
        maxWidth: '100%',
        fontSize: '9px',
        overflowX: 'auto',
    },
    ' .muk-datepicker-picker': {
        border: '1px solid #ccc',
    },
    ' #flood-fill-points': {
        maxWidth: '100%',
        maxHeight: '200px',
        width: 'auto',
        height: 'auto',
        boxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        webkitBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
        mozBoxShadow: '0 0 3px 1px rgba(0,0,0,.3)',
    }
})

const StyledLayoutsGrid = css(Grid)({
    gridTemplateColumns: `repeat(auto-fit, minmax(${layoutSize+10}px, 1fr))`,
    gridGap: '5px',
    marginTop: '20px',
    ' .muk-gridcell': {
        padding: '10px 0',
        alignSelf: 'center',
        textAlign: 'center',
        verticalAlign: 'middle',
        cursor: 'pointer',
        ':hover': {
            backgroundColor: '#efefef',
        },
    },
    ' .layout-name': {
        color: Theme.blue,
        fontSize: '10px',
        width: '100%',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
    },
    ' .temporary': {
        color: Theme.red,
    },
    ' .add-layout-button': {
        padding: '10px',
        color: Theme.blue,
        ' svg': {
            height: `${layoutSize-10}px`,
            width: `${layoutSize-10}px`,
            paddingBottom: '10px',
            strokeWidth: '1px',
            padding: '25px',
            border: `1px solid ${Theme.blue}`,
        },
    },

    ".choose-layout": {
        border: "1px solid #ccc",
        "&.selected": {
            borderColor: "#555",
            background: "#e1e1e1",
        },
    },
    ".alt-image-layout": {
        fill: "#e5f2ff",
        stroke: "#17afaf",
        strokeWidth: "1px",
    }
})

const StyledToggler = css(Toggler)({
    ' .m-isinvalid': {
        float: 'right',
    },
})


function mapStateToProps(state) {
    return {
        randomProduct: state.randomProduct,
        helper: state.helper,
        templateForm: selectFormValues(state,'templateForm'),
        collageLayoutsForm: selectFormValues(state,'collageLayoutsForm'),
    }
}

export default connect(mapStateToProps, {
    change,
    initForm,
    setHelper,
})(EditLayout)
